export default __webpack_public_path__ + "static/media/statusBar.fdffc1b7.png";